import { render, staticRenderFns } from "./MedicalImaging.vue?vue&type=template&id=d567a21c&scoped=true"
import script from "./MedicalImaging.vue?vue&type=script&lang=js"
export * from "./MedicalImaging.vue?vue&type=script&lang=js"
import style0 from "./MedicalImaging.vue?vue&type=style&index=0&id=d567a21c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d567a21c",
  null
  
)

export default component.exports